import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetCategorys({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("CATEGORY_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/kategori", option);
    commit("CATEGORY_SUCCESS", _response);
  } catch (error) {
    commit("CATEGORY_ERROR", { result: error.message });
  }
}

export async function CreateCategory({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("CREATE_CATEGORY_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/kategori", form);
    commit("CREATE_CATEGORY_SUCCESS", _response);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_CATEGORY_ERROR", { result: error.message });
  }
}

export async function GetCategory({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_CATEGORY_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/v1/kategori/kategori-id", id);
    commit("GET_CATEGORY_SUCCESS", _response.data);
  } catch (error) {
    commit("GET_CATEGORY_ERROR", { result: error.message });
  }
}

export async function UpdateCategory({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_CATEGORY_REQUEST");
    ApiService.setHeader();
    if (form.parentId) {
      form.parentId = form.parentId.split(" - ")[0];
    }
    await ApiService.put("/v1/kategori/" + form.kategoriId, form);
    commit("EDIT_CATEGORY_SUCCESS", form);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_CATEGORY_ERROR", { result: error.message });
  }
}

export async function DeleteCategory({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_CATEGORY_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/category/" + id);
    commit("DELETE_CATEGORY_SUCCESS", { id: id });
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_CATEGORY_ERROR", { result: error.message });
  }
}
